import { styled } from 'styled-components';

export const ImageContainer = styled.div`
  margin-bottom: 32px;

  img {
    width: 100%;
    height: auto;
  }
`;

export const ListingViewDescriptionSectionImageHolder = styled.div`
  margin-bottom: 64px;

  img {
    height: auto;
  }
`;
